// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "memory-worker" + "." + "28e28d4be60fba2accad" + ".js";
};